import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';
import { CardExpandToggler } from '../../../components/card/card';

function RadarChart({data}) {

  var id = data.reportChartId;
  const chartRef = useRef(null);

  useEffect(() => {
    var themeColor = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
		var themeColorRgb = (getComputedStyle(document.body).getPropertyValue('--bs-theme-rgb')).trim();
		var gray900 = (getComputedStyle(document.body).getPropertyValue('--bs-gray-900')).trim();
		var gray900Rgb = (getComputedStyle(document.body).getPropertyValue('--bs-gray-900-rgb')).trim();
		var gray800Rgb = (getComputedStyle(document.body).getPropertyValue('--bs-gray-800-rgb')).trim();
		var gray500 = (getComputedStyle(document.body).getPropertyValue('--bs-gray-500')).trim();
		var gray500Rgb = (getComputedStyle(document.body).getPropertyValue('--bs-gray-500-rgb')).trim();
		var gray300Rgb = (getComputedStyle(document.body).getPropertyValue('--bs-gray-300-rgb')).trim();
		
		var bodyBg = (getComputedStyle(document.body).getPropertyValue('--bs-body-bg')).trim();
		var bodyFontFamily = (getComputedStyle(document.body).getPropertyValue('--bs-body-font-family')).trim();
		var bodyFontWeight = (getComputedStyle(document.body).getPropertyValue('--bs-body-font-weight')).trim();
		var bodyColor = (getComputedStyle(document.body).getPropertyValue('--bs-body-color')).trim();
		var borderColor = (getComputedStyle(document.body).getPropertyValue('--bs-border-color')).trim();
		var inverse = (getComputedStyle(document.body).getPropertyValue('--bs-inverse')).trim();
		var inverseRgb = (getComputedStyle(document.body).getPropertyValue('--bs-inverse-rgb')).trim();

    Chart.defaults.font.family = bodyFontFamily;
		Chart.defaults.font.size = 12;
		Chart.defaults.color = bodyColor;
		Chart.defaults.borderColor = borderColor;
		Chart.defaults.plugins.legend.display = true;
		Chart.defaults.plugins.tooltip.padding = { left: 8, right: 12, top: 8, bottom: 8 };
		Chart.defaults.plugins.tooltip.cornerRadius = 8;
		Chart.defaults.plugins.tooltip.titleMarginBottom = 6;
		Chart.defaults.plugins.tooltip.titleFont.family = bodyFontFamily;
		Chart.defaults.plugins.tooltip.titleFont.weight = bodyFontWeight;
		Chart.defaults.plugins.tooltip.footerFont.family = bodyFontFamily;
		Chart.defaults.plugins.tooltip.displayColors = true;
		Chart.defaults.plugins.tooltip.boxPadding = 6;
		Chart.defaults.scale.grid.color = borderColor;
		Chart.defaults.scale.beginAtZero = true;




     var existingChart = chartRef.current;

    if (existingChart) {
      existingChart.destroy();
    }


		const newChart =  new Chart(document.getElementById(id), {
      type: 'radar',
      data: {
        // labels: ['United States', 'Canada', 'Australia', 'Netherlands', 'Germany', 'New Zealand', 'Singapore'],
        labels: data?.kpiNames || [],
        datasets: [{
          label: 'Mobile',
          // backgroundColor: 'rgba('+ themeColorRgb +', .2)',
          // borderColor: themeColor,
          // pointBackgroundColor: bodyBg,
          // pointBorderColor: themeColor,
          // pointHoverBackgroundColor: bodyBg,
          // pointHoverBorderColor: themeColor,
          data: [65, 59, 90, 81, 56, 55, 40],
          borderWidth: 1.5
        }, {
          label: 'Desktop',
          // backgroundColor: 'rgba('+ gray500Rgb +', .2)',
          // borderColor: gray500,
          // pointBackgroundColor: bodyBg,
          // pointBorderColor: gray500,
          // pointHoverBackgroundColor: bodyBg,
          // pointHoverBorderColor: gray500,
          data: [28, 48, 40, 19, 96, 27, 100],
          borderWidth: 1.5
        }]
      }
    });

    chartRef.current = newChart;
    
    // eslint-disable-next-line
  }, []);
  
  return (
    <div>
            <div className="d-flex fw-bold small p-3 bg-theme bg-opacity-20">
        <span className="flex-grow-1">{data?.title}</span>
        <CardExpandToggler />
      </div>
      <canvas id={id}></canvas>
    </div>
  )
}

export default RadarChart;